import styled from 'styled-components'
import { bigLg, media } from 'utils/style-utils'

export const SlideBox = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  height: 100%;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const Content = styled.div`
  position: relative;
  height: calc(100% - 3.5rem);
  max-width: ${bigLg}px;
  margin: 0 auto;
  top: 3.5rem;

  ${media.sm`
    height: calc(100% - 7rem);
  `}
`

export const Description = styled.div`
  padding: 3rem;
  width: 30%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media.sm`
    width: 100%;
    height: 50%;
    position: absolute;
    bottom: 0;
    text-align: center;
  `}
`

export const Title = styled.h2`
  margin: 0.5rem 0;

  font-size: 2rem;
  font-weight: bold;
`

export const Subtitle = styled.h3`
  margin: 0.5rem 0 2rem;

  font-size: 1rem;
  font-weight: normal;
`

export const ImageStyle = styled.div`
  width: 60%;
  height: 100%;

  position: absolute;
  z-index: 11;
  top: 0;
  right: 0;

  background-size: 500px;
  background-position: center;
  background-repeat: no-repeat;

  ${media.sm`
    width: 100%;
    height: 50%;
    background-size: 100%;
  `}
`
